<template>
  <u-table
    ref="plTable"
    :data="tableData"
    :height="height"
    use-virtual
    showBodyOverflow="title"
    showHeaderOverflow="title"
    :row-height="rowHeight"
    :show-header="false"
    :data-changes-scroll-top="false"
    border
  >
    <!-- <u-table-column type="index" width="100" fixed/> -->
    <u-table-column label="" field="houseNumber">
      <template slot-scope="scope">
        <div class="flex">
          <CuInput
            @inputChange="pointChange"
            type="number"
            :item="scope.row"
            itemKey="houseNumber"
            :maxLength="10"
            :scope="scope"
            :defaultValue="scope.row.houseNumber || '0'"
            placeholder="号(例：1)"
          />
          <a-button
            v-if="scope.$index == tableData.length - 1"
            type="link"
            @click="addNumHandle('houseNumber', scope.row)"
            ><a-icon type="plus-circle"
          /></a-button>
        </div>
      </template>
    </u-table-column>
    <u-table-column label="" field="attachedNumber">
      <template slot-scope="scope">
        <div class="flex">
          <CuInput
            @inputChange="pointChange"
            type="number"
            :item="scope.row"
            itemKey="attachedNumber"
            :maxLength="10"
            :defaultValue="scope.row.houseNumber || '0'"
            placeholder="号(例：1)"
          />
          <a-button
            v-if="scope.$index == tableData.length - 1"
            type="link"
            @click="addNumHandle('attachedNumber', scope.row)"
            ><a-icon type="plus-circle"
          /></a-button>
        </div>
      </template>
    </u-table-column>
    <u-table-column label="" field="industryCategoryId" edit-render>
      <template slot-scope="scope">
        <CuSelect
          @change="industryCategoryChange"
          :index="scope.$index"
          :item="scope.row"
          itemKey="industryCategoryId"
          :options="industryClass"
          placeholder="行业大类"
        />

        <CuSelect
          @change="industrySubCategoryChange"
          :index="scope.$index"
          :item="scope.row"
          itemKey="industrySubclassId"
          :options="scope.row.showIndustrySubclass"
          placeholder="行业小类"
        />
      </template>
    </u-table-column>
    <u-table-column label="" field="industryCategoryId">
      <template slot-scope="scope">
        <CuInput :item="scope.row" itemKey="brandName" :maxLength="20" placeholder="请输入品牌信息" />
      </template>
    </u-table-column>
    <u-table-column label="操作" fixed="right">
      <template slot-scope="scope">
        <a-button class="" type="link" v-if="tableData.length != 1" @click="removeHandle(scope.row, scope.$index)">
          <a-icon type="minus-circle" />
        </a-button>
      </template>
    </u-table-column>
  </u-table>
</template>
<script>
import CuInput from './cu-input.vue'
import CuSelect from './cu-select.vue'
export default {
  components: {
    CuInput,
    CuSelect,
  },
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    industryClass: {
      type: Array,
      default: () => [],
    },
    industrySubclass: {
      type: Array,
      default: () => [],
    },
    height: {
      type: [String, Number],
      default: 800,
    },
    rowHeight: {
      type: [String, Number],
      default: 40,
    },
  },
  watch: {
    tableData: {
      handler() {
        console.log(this.tableData, '999999')
      },
      deep: true,
      immediate: true,
    },
    industryClass: {
      handler() {},
      deep: true,
      immediate: true,
    },
    industrySubclass: {
      handler() {},
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {}
  },
  methods: {
    addNumHandle(type, item) {
      this.$emit('addNumHandle', type, item)
      this.$nextTick(() => {
        this.$refs.plTable.scrollBottom()
      })
    },
    industryCategoryChange(item, index) {
      this.tableData.forEach((el) => {
        if (el.id === item.id) {
          el.showIndustrySubclass = this.industrySubclass.filter((it) => it.parentId == item.industryCategoryId)
        }
      })
      // console.log(item,'item')
      this.$emit('industryCategoryChange', item, index, this.tableData)
    },
    industrySubCategoryChange(item, index) {
      this.$emit('industrySubCategoryChange', item, index)
    },
    removeHandle(item, index) {
      this.$emit('removeHandle', item, index)
    },
    pointChange(e, value, name) {
      this.$emit('pointChange', e, value, name)
    },
  },
}
</script>
